import {FC, useCallback} from 'react';
import {Plan} from "@memaro/api"
import {PlanDefinition, plans} from "../../../constants/profile.ts";
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from "@mui/material/TableBody";
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableFooter from '@mui/material/TableFooter';
import {formatMoney} from "../../../lib/money.ts";
import MenuItem from "@mui/material/MenuItem";
import {SelectChangeEvent} from "@mui/material/Select/SelectInput";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";

type PaymentOverviewProps = {
    selectedPlan: Plan;
    yearsUpfront: number;
    onChangeYearsUpfront: (val: number) => void;
}

const PaymentOverview: FC<PaymentOverviewProps> = ({selectedPlan, yearsUpfront, onChangeYearsUpfront}) => {
    const plan = plans.find(p => p.plan == selectedPlan) as PlanDefinition
    const totalPrice = plan.price * yearsUpfront
    const totalPriceExcludingTax = totalPrice / 1.21
    const tax = totalPrice - totalPriceExcludingTax

    const handleChangeYearsUpfront = useCallback(
        (e: SelectChangeEvent<number>) => onChangeYearsUpfront(typeof e.target.value == "number" ? e.target.value : 10),
        [onChangeYearsUpfront],
    )

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell component="th"></TableCell>
                    <TableCell component="th">Termijn</TableCell>
                    <TableCell component="th" align="right">Prijs per jaar</TableCell>
                    <TableCell component="th" align="right">Totaalprijs</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell scope="row">
                        <Typography fontWeight="bold" component="span" sx={{marginRight: 1}}>{plan.title}</Typography>
                    </TableCell>
                    <TableCell width={220}>
                        <Select size="small" value={yearsUpfront} onChange={handleChangeYearsUpfront} autoWidth={false}>
                            <MenuItem value={5}>5 jaar vooruit betalen</MenuItem>
                            <MenuItem value={10}>10 jaar vooruit betalen</MenuItem>
                            <MenuItem value={15}>15 jaar vooruit betalen</MenuItem>
                            <MenuItem value={20}>20 jaar vooruit betalen</MenuItem>
                        </Select>
                    </TableCell>
                    <TableCell align="right" valign="top">
                        {formatMoney(plan.price)}
                    </TableCell>
                    <TableCell align="right">
                        {formatMoney(plan.price * yearsUpfront)}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell scope="row" colSpan={3}>
                        Totaal (excl. BTW)
                    </TableCell>
                    <TableCell align="right">
                        {formatMoney(totalPriceExcludingTax)}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell scope="row" colSpan={3}>
                        BTW (21%)
                    </TableCell>
                    <TableCell align="right">
                        {formatMoney(tax)}
                    </TableCell>
                </TableRow>
            </TableBody>
            <TableFooter>
                <TableRow>
                    <TableCell colSpan={3}>Totaal</TableCell>
                    <TableCell align="right">{formatMoney(plan.price * yearsUpfront)}</TableCell>
                </TableRow>
            </TableFooter>
        </Table>
    );
};

export default PaymentOverview;
